import type { trpc } from "@/lib/trpc";
import type { inferOutput } from "@trpc/tanstack-react-query";

export type ProjectOutput = inferOutput<typeof trpc.projects.getAll>[number];
export type ProjectBySlugOutput = inferOutput<typeof trpc.projects.getBySlug>;

export type EnvironmentOutput = ProjectBySlugOutput["environments"][number];

export type TemplateListPublishOutput = inferOutput<
  typeof trpc.templates.templates.getAllPublished
>[number];

export type TemplatePreviewOutput = inferOutput<
  typeof trpc.templates.templates.getPublishedTemplate
>;

export type TemplateListDraftOutput = inferOutput<typeof trpc.templates.drafts.getAll>[number];

export type ApiKeyOutput = inferOutput<typeof trpc.apiKeys.getAll>[number];

export const authViewPaths = {
  SIGN_IN: "sign-in",
  SIGN_UP: "sign-up",
  SIGN_OUT: "sign-out",
  MAGIC_LINK: "magic-link",
  FORGOT_PASSWORD: "forgot-password",
  RECOVER_ACCOUNT: "recover-account",
  CALLBACK: "callback",
  EMAIL_OTP: "email-otp",
  RESET_PASSWORD: "reset-password",
  TWO_FACTOR: "two-factor",
  ACCEPT_INVITATION: "accept-invitation",
  ORGANIZATION: "organization",
} as const;

export type AuthViewPath = (typeof authViewPaths)[keyof typeof authViewPaths];

export const nonAuthViews: AuthViewPath[] = [
  authViewPaths.SIGN_IN,
  authViewPaths.SIGN_UP,
  authViewPaths.MAGIC_LINK,
  authViewPaths.FORGOT_PASSWORD,
  authViewPaths.RECOVER_ACCOUNT,
  authViewPaths.CALLBACK,
];
